/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Deep_Tissue_MassageInputs */

const en_service_type_deep_tissue_massage = /** @type {(inputs: Service_Type_Deep_Tissue_MassageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep tissue massage`)
};

const pl_service_type_deep_tissue_massage = /** @type {(inputs: Service_Type_Deep_Tissue_MassageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masaż tkanek głębokich`)
};

/**
* | output |
* | --- |
* | "Deep tissue massage" |
*
* @param {Service_Type_Deep_Tissue_MassageInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_deep_tissue_massage = /** @type {((inputs?: Service_Type_Deep_Tissue_MassageInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Deep_Tissue_MassageInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_deep_tissue_massage(inputs)
	return en_service_type_deep_tissue_massage(inputs)
});